import React from 'react';
import AdminNav from '../../components/admin/AdminNav';
import InvitedList from '../../components/admin/InvitedList';
import AdminLayout from '../../layouts/AdminLayout';

const AdminDashboard = () => (
  <AdminLayout>
    <AdminNav />
    <InvitedList />
  </AdminLayout>
);

export default AdminDashboard;
